export const enum NotificationChannel {
    None = `none`,
    Push = `push`,
    Web = `web`,
    All = `all`,
}

export enum RedirectType {
    ProductCategory = `product_category`,
    Product = `product`,
    NewsArticle = `news_article`,
    LiveBroadcast = `live_broadcast`,
    Url = `url`,
}

export type NotificationParameters = {
    redirect_type: RedirectType;
    redirect_entity_value: number | string;
    redirect_entity_title: string;
};

export type NotificationModel = {
    id: number;
    title: string;
    text: string | null;
    channel: NotificationChannel;
    is_important: boolean;
    send_at: string;
    is_sent: boolean;
    parameters: NotificationParameters | null;
};

export type NotificationTemplateModel = {
    id: number;
    title: string;
    text: string | null;
};
